var React = require('react');

function SocialmediaInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3V3ZM18 5H15.5C14.5717 5 13.6815 5.36875 13.0251 6.02513C12.3687 6.6815 12 7.57174 12 8.5V11H10V14H12V21H15V14H18V11H15V9C15 8.73478 15.1054 8.48043 15.2929 8.29289C15.4804 8.10536 15.7348 8 16 8H18V5Z","fill":"black"}));
}

SocialmediaInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SocialmediaInline;

SocialmediaInline.default = SocialmediaInline;
